import { FeaturedWorkoutsSection } from './featured-workouts-section'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useCatalogAccess } from 'src/hook/use-catalog-access'

/**
 * The featured shelf as it appears on Home.
 *
 * Visible **only** to accounts without full catalog access, and on no other condition — an
 * account that can already play everything has no use for a shelf advertising three of them.
 * Once the account subscribes the section disappears on its own, because the config query is
 * invalidated on `SUBSCRIPTION.CREATE` (see `session-context.tsx`).
 *
 * **Nothing renders until the config answers.** `hustlerConfig` starts on a fail-closed
 * default, so hiding on the predicate alone meant a subscriber watched the whole section
 * mount — heading, subtitle, skeletons, then the loaded cards — before it vanished. It also
 * fired the `/workouts/featured` request for an account that would never see the result.
 * `isLoading` is the third state that makes both impossible.
 *
 * Hiding uses `isDefinitelyEntitled`, never `hasFullCatalogAccess`: the latter fails open, and
 * on this axis failing open inverts into hiding the free shelf from precisely the people it
 * exists for whenever a RevenueCat lookup blips.
 *
 * Playing routes to the standard workout page, same as every other shelf on Home.
 */
export const HomeFeaturedWorkouts = (): React.ReactElement => {
  const { isDefinitelyEntitled, isLoading } = useCatalogAccess()
  const navigate = useNavigate()

  if (isLoading || isDefinitelyEntitled) return <></>

  return <FeaturedWorkoutsSection surface="home" onSelectWorkout={(workout) => navigate(`/workouts/${workout.id}`)} />
}
